import React from 'react';

const EntityInvestCompany = ({ formData, handleChange }) => {  
    const hideSectionI = ![
        formData.entityInvestmentCompany.lessThanTenPercent,
        formData.entityInvestmentCompany.notFormedForFund,
        formData.entityInvestmentCompany.lessThanFortyPercentAssets,
        formData.entityInvestmentCompany.priorInvestments,
        formData.entityInvestmentCompany.governingDocuments,
        formData.entityInvestmentCompany.collectiveInvestment
      ].includes("false");
        
    return (
        <div>
            <fieldset className="form-field">
                <legend>(a) The Subscriber is one of the following:</legend>
                <legend className='question_indent'>(1) an “investment company,” as defined in Section 3(a) of the Investment Company Act, registered or required to be registered under the Investment Company Act; or</legend>
                <legend className='question_indent'>(2) a “business development company,” as defined in Section 2(a)(48) of the Investment Company Act.</legend>
                    <label className='subChoice_indent'><input type="radio" name="entityInvestmentCompany.investOrBusiness" value="true" checked={formData.entityInvestmentCompany.investOrBusiness === 'true'} onChange={handleChange} required/>
                        True
                    </label>
                    <br />
                    <label className='subChoice_indent'><input type="radio" name="entityInvestmentCompany.investOrBusiness" value="false" checked={formData.entityInvestmentCompany.investOrBusiness === 'false'} onChange={handleChange} />
                        False
                    </label>
            </fieldset>

            <fieldset className="form-field">
                <legend>
                    (b) The Subscriber would be an “investment company” as defined in Section 3(a) of the Investment Company Act if it were not exempt from such definition due to Section 3(c)(1) or Section 3(c)(7) of the Investment Company Act.
                </legend>
                    <label><input type="radio" name="entityInvestmentCompany.investmentCompany" value="true" checked={formData.entityInvestmentCompany.investmentCompany === 'true'} onChange={handleChange} required/>
                        True
                    </label>
                    <br />
                    <label>
                        <input type="radio" name="entityInvestmentCompany.investmentCompany" value="false" checked={formData.entityInvestmentCompany.investmentCompany === 'false'} onChange={handleChange} />
                        False
                    </label>
            </fieldset>

            {(
            formData.entityInvestmentCompany.investOrBusiness === 'true' ||
            formData.entityInvestmentCompany.investmentCompany === 'true'
            ) && (
                <fieldset className="form-field">
                    <legend>
                        (c) If the answer to Part II(a) or (b) above is “True,” the Subscriber’s commitment to the Fund is less than ten percent (10%) of the Fund’s committed capital (leave blank if the answers to both Part II(a) and (b) above are “False”).
                    </legend>
                    <label>
                        <input
                            type="radio"
                            name="entityInvestmentCompany.lessThanTenPercent"
                            value="true"
                            checked={formData.entityInvestmentCompany.lessThanTenPercent === 'true'}
                            onChange={handleChange}
                            required
                        />
                        True
                    </label>
                    <br />
                    <label>
                        <input
                            type="radio"
                            name="entityInvestmentCompany.lessThanTenPercent"
                            value="false"
                            checked={formData.entityInvestmentCompany.lessThanTenPercent === 'false'}
                            onChange={handleChange}
                        />
                        False
                    </label>
                </fieldset>
            )}

            <fieldset className="form-field">
                <legend>
                    (d) The Subscriber was not formed or reformed (as interpreted under the Investment Company Act) for the purpose of acquiring interests of the Fund. 
                </legend>
                <label>
                    <input type="radio" name="entityInvestmentCompany.notFormedForFund" value="true" checked={formData.entityInvestmentCompany.notFormedForFund === 'true'} onChange={handleChange} required/>
                    True
                </label>
                <br />
                <label>
                    <input type="radio" name="entityInvestmentCompany.notFormedForFund" value="false" checked={formData.entityInvestmentCompany.notFormedForFund=== 'false'} onChange={handleChange} />
                    False
                </label>
            </fieldset>

            <fieldset className="form-field">
                <legend>
                    (e) The Subscriber’s commitment to the Fund is less than forty percent (40%) of the Subscriber’s assets (including committed capital).
                </legend>
                <label>
                    <input 
                        type="radio" 
                        name="entityInvestmentCompany.lessThanFortyPercentAssets" 
                        value="true" 
                        checked={formData.entityInvestmentCompany.lessThanFortyPercentAssets === 'true'} 
                        onChange={handleChange}
                        required
                    />
                    True
                </label>
                <br />
                <label>
                    <input type="radio" name="entityInvestmentCompany.lessThanFortyPercentAssets" value="false" checked={formData.entityInvestmentCompany.lessThanFortyPercentAssets === 'false'} onChange={handleChange} />
                    False
                </label>
            </fieldset>

            <fieldset className="form-field">
                <legend>
                    (f) The Subscriber has made investments prior to the date hereof or intends to make investments in the near future and each beneficial owner of interests in the Subscriber has shared and will share in the same proportion in each such investment (e.g., no beneficial owner of the Subscriber may vary its interests in different investments made by or on behalf of the Subscriber).
                </legend>
                <label>
                    <input type="radio" name="entityInvestmentCompany.priorInvestments" value="true" checked={formData.entityInvestmentCompany.priorInvestments === 'true'} onChange={handleChange} required/>
                    True
                </label>
                <br />
                <label>
                    <input type="radio" name="entityInvestmentCompany.priorInvestments" value="false" checked={formData.entityInvestmentCompany.priorInvestments === 'false'} onChange={handleChange} />
                    False
                </label>
            </fieldset>

            <fieldset className="form-field">
                <legend>
                    (g) The governing documents of the Subscriber require that each beneficial owner of the Subscriber including, but not limited to, shareholders, partners and beneficiaries, participate through his, her or its interest in the Subscriber in all of the Subscriber’s investments and that the profits and losses from each such investment are shared among such beneficial owners in the same proportions as all other investments of the Subscriber.  No such beneficial owner may vary his, her or its share of the profits and losses or the amount of his, her or its contribution for any investment made by the Subscriber.
                </legend>
                <label>
                    <input type="radio" name="entityInvestmentCompany.governingDocuments" value="true" checked={formData.entityInvestmentCompany.governingDocuments === 'true'} onChange={handleChange} required/>
                    True
                </label>
                <br />
                <label>
                    <input type="radio" name="entityInvestmentCompany.governingDocuments" value="false" checked={formData.entityInvestmentCompany.governingDocuments === 'false'} onChange={handleChange} />
                    False
                </label>
            </fieldset>

            <fieldset className="form-field">
                <legend>
                    (h) The Subscriber is not managed as a device for facilitating individual investment decisions of its beneficial owners, but rather is managed as a collective investment vehicle (e.g., no beneficial owner of the Subscriber has the right to “opt out” of an investment or has individual discretion over the amount of his, her or its investment).
                </legend>
                <label>
                    <input type="radio" name="entityInvestmentCompany.collectiveInvestment" value="true" checked={formData.entityInvestmentCompany.collectiveInvestment === 'true'} onChange={handleChange} required/>
                    True
                </label>
                <br />
                <label>
                    <input type="radio" name="entityInvestmentCompany.collectiveInvestment" value="false" checked={formData.entityInvestmentCompany.collectiveInvestment === 'false'} onChange={handleChange} />
                    False
                </label>
            </fieldset>

            {!hideSectionI && (
            <fieldset className="form-field">
                <legend>
                (i) If the Subscriber answered “False” to any of Part II(c), (d), (e), (f), (g), or (h) above, the Subscriber hereby makes the representations, warranties and covenants listed in the footnote below⁵ and hereby represents that the number of direct or indirect beneficial owners of the Subscriber’s securities as interpreted under the Investment Company Act (other than short-term paper, as such term is interpreted under the Investment Company Act) is
                <span className="info-icon" title={"⁵ The Subscriber hereby represents, warrants and covenants with respect to each beneficial owner of the Subscriber’s securities (each, a “Beneficial Owner”) that: \n\n(i) the Subscriber is sufficiently familiar with each such Beneficial Owner’s regulatory status and/or Investment ownership to make representations on each such Beneficial Owner’s behalf; \n\n(ii) each such Beneficial Owner is sufficiently qualified in such Beneficial Owner’s own right to make a direct investment in the Fund under the requirements set forth in this Investor Qualification Statement (i.e., as an “accredited investor,” a “qualified client” and a “qualified purchaser”, in each case, to the extent the Subscriber meets any such qualification on its own right as indicated herein);"}>ⓘ</span>
                <span className="info-icon" title={"(iii) the Fund may rely on the Subscriber’s representations on behalf of each such Beneficial Owner hereunder to the same extent as if each such Beneficial Owner had completed this Investor Qualification Statement or the Investor Qualification Statement for Individuals; and \n\n(iv) the Subscriber shall permit no direct or indirect changes in beneficial ownership in the Subscriber that at any time would result in any of the representations contained in clauses (i)-(iii) ceasing to be true."}>ⓘ</span>
                </legend>
                <legend>
                <input
                    type="text"
                    name="entityInvestmentCompany.beneficialOwners"
                    value={formData.entityInvestmentCompany.beneficialOwners}
                    onChange={handleChange}
                />
                ⁶
                <span className="info-icon" title={"⁶ The Subscriber hereby represents, warrants and consents that the Subscriber shall permit no direct or indirect changes in the Subscriber’s beneficial ownership that at any time would increase the number of deemed beneficial owners provided in the response."}>ⓘ</span>
                </legend>
            </fieldset>
            )}
        </div>
    );
};

export default EntityInvestCompany;